import styled from "styled-components"

const Logo = styled.img`
  margin-bottom: 0;
  width: 100%;
  max-width: ${props => (props.maxWidth ? props.maxWidth : "55%")};
`

export default Logo
